import { fmt } from '../lib/money.js';
import { useStore } from '../lib/store.jsx';
import { useI18n } from '../lib/i18n.jsx';
import ProductViz from './ProductViz.jsx';

export default function CartDrawer({ nav }) {
  const { cart, cartQty, cartSubtotal, setQty, removeItem, drawerOpen, setDrawerOpen, P } = useStore();
  const { t } = useI18n();
  const close = () => setDrawerOpen(false);
  const goto = (path) => { close(); nav(path); };

  return (
    <aside className={`drawer${drawerOpen ? ' show' : ''}`} aria-label={t('cart.aria')}>
      <div className="dhead">
        <h3>{cart.length ? `${t('cart.title')} · ${cartQty}` : t('cart.title')}</h3>
        <button className="x" onClick={close}>✕</button>
      </div>
      {cart.length === 0 ? (
        <div className="dbody">
          <div className="emptycart">
            <div className="k">Empty</div>
            <p>{t('cart.empty')}</p>
            <button className="btn ghost sm" onClick={() => goto('/c/all')}>{t('cart.start')}</button>
          </div>
        </div>
      ) : (
        <>
          <div className="dbody">
            {cart.map((i) => {
              const p = P(i.id) || i;
              return (
                <div className="citem" key={i.key}>
                  <div className="th"><ProductViz product={p} size="sm" /></div>
                  <div>
                    <div className="nm" onClick={() => goto(`/p/${i.sku}`)}>{i.name}</div>
                    {i.variant && <div className="vr">{i.variant}</div>}
                    <div className="qty">
                      <button onClick={() => setQty(i.key, -1)}>−</button>
                      <span>{i.qty}</span>
                      <button onClick={() => setQty(i.key, 1)}>＋</button>
                    </div>
                    <div className="rm" onClick={() => removeItem(i.key)}>{t('cart.remove')}</div>
                  </div>
                  <div className="pr">{fmt(i.unitPrice * i.qty)}</div>
                </div>
              );
            })}
          </div>
          <div className="dfoot">
            <div className="sumrow"><span>{t('cart.subtotal')}</span><span>{fmt(cartSubtotal)}</span></div>
            <div className="sumrow"><span>{t('cart.ship')}</span><span>{t('cart.shipLater')}</span></div>
            <div className="sumrow tot"><span>{t('cart.total')}</span><b>{fmt(cartSubtotal)}</b></div>
            <button className="btn full" style={{ marginTop: 14 }} onClick={() => goto('/checkout')}>
              {t('cart.checkout')}
            </button>
          </div>
        </>
      )}
    </aside>
  );
}
